<template>
<div class="work-container">
  <div class="header">
    <img src="../assets/margot-arrow.png" @click="navigateHome" class="margot-image">
  </div>

  <div class='work-description'>
Ik toon jullie hier al een paar van mijn werken. Later komen er meer. Als je geïnteresseerd bent in een van deze werken, laat mij dan iets weten op <img class="work-email" src="../assets/email.png">

  </div>
  <galleryView></galleryView>
</div>
  
</template>

<script>
import GalleryView from './GalleryView.vue';
import Router from "vue-router";

export default {
  name: 'Work',
  components: {
    GalleryView
  },
  methods:{
    navigateHome() {
      this.$router.push({path:'home'});
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.header{
  width:100%;
  /* position:fixed; */
  background:white;
  z-index: 2;
}

.work-container {
    margin: 0 3rem;
}

.work-description {
  /* padding: 6rem 15px 2rem 15px; */
  padding: 2rem 15px;
}

.margot-image {
  width: 13rem;
  cursor: pointer;
  padding-left: 15px;
  margin:1rem 0;
}

.work-email {
  height: 1rem;
  margin-bottom: 1px;
}

</style>